import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.onload = () => { 
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_APP_KEY,
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        wsHost: process.env.MIX_PUSHER_APP_HOST,
        wsPort: process.env.MIX_PUSHER_APP_PORT ?? 6001,
        wssPort: process.env.MIX_PUSHER_APP_PORT ?? 6001,
        forceTLS: process.env.MIX_PUSHER_APP_ENCRYPTED == "true",
    });

    window.dispatchEvent(new CustomEvent('EchoLoaded'));
}